import {
  Paper, Table, TableHead, TableRow, TableCell, TableBody, Typography, Box, Chip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import type { Application } from '../../types/application';
import { APPLICATION_STATUS_COLORS } from '../../../../constants/statusColors';

interface Props {
  applications: Application[];
}

const RecentApplicationsTable = ({ applications }: Props) => {
  const navigate = useNavigate();

  const recent = applications
    .filter((a) => a.created_at)
    .sort((a, b) => (b.created_at?.toMillis?.() ?? b.created_at?.seconds ?? 0) - (a.created_at?.toMillis?.() ?? a.created_at?.seconds ?? 0))
    .slice(0, 5);

  const formatDevices = (devices: { deviceType: string; deviceModel: string }[]) => {
    if (!devices || devices.length === 0) return '-';
    return devices.map((d) => `${d.deviceType} (${d.deviceModel.split(' - ')[0]})`).join(', ');
  };

  return (
    <Paper elevation={0} sx={{
      p: { xs: 2, md: 3 }, borderRadius: 3,
      border: '1px solid #e5e7eb', height: '100%',
    }}>
      <Typography fontWeight={700} sx={{ fontSize: '0.95rem', color: '#0f172a', mb: 2 }}>
        최근 신청 5건
      </Typography>
      <Box sx={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{
              '& th': {
                fontWeight: 700, fontSize: '0.78rem', color: '#64748b',
                borderBottom: '1px solid #e5e7eb', py: 1, bgcolor: '#f8fafc',
              },
            }}>
              <TableCell>번호</TableCell>
              <TableCell>이름</TableCell>
              <TableCell>기기</TableCell>
              <TableCell>신청일</TableCell>
              <TableCell>상태</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {recent.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 4, color: '#94a3b8' }}>
                  신청 내역이 없습니다
                </TableCell>
              </TableRow>
            ) : recent.map((row) => (
              <TableRow
                key={row.id}
                hover
                onClick={() => navigate(`/admin/applications/${row.id}`)}
                sx={{ cursor: 'pointer', '&:hover': { bgcolor: '#f8fafc' } }}
              >
                <TableCell sx={{ fontWeight: 700, fontSize: '0.82rem' }}>{row.application_number}</TableCell>
                <TableCell sx={{ fontSize: '0.82rem' }}>{row.user_name}</TableCell>
                <TableCell sx={{ fontSize: '0.78rem', maxWidth: 160, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                  {formatDevices(row.devices)}
                </TableCell>
                <TableCell sx={{ fontSize: '0.78rem', color: '#64748b' }}>
                  {row.created_at?.toDate ? dayjs(row.created_at.toDate()).format('MM/DD') : '-'}
                </TableCell>
                <TableCell>
                  <Chip
                    label={row.status}
                    size="small"
                    sx={{
                      fontWeight: 700, fontSize: '0.7rem',
                      color: APPLICATION_STATUS_COLORS[row.status] || '#555',
                      bgcolor: (APPLICATION_STATUS_COLORS[row.status] || '#555') + '14',
                      border: 'none', height: 24,
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Paper>
  );
};

export default RecentApplicationsTable;
